/**
 * v3 main onboarding — single layout / motion config (iOS values are the visual baseline).
 * Android overrides live in `onboardingMainScreenAndroidParity.ts` and motion platform branches.
 */
import { appTheme } from '../theme';
import { MAIN_SCREEN_PANEL_MAX_WIDTH } from './authOverlayPresentation';

export const MAIN_SCREEN_HERO = {
  cardHeightFraction: 0.86,
  cardTopOffsetFraction: -0.01,
} as const;

export const MAIN_SCREEN_DOCK = {
  /** Auth forms — topmost layer when the dock is open. */
  floatZ: 500,
  /** Dim layer sits under the hero card. */
  backdropZ: 300,
  /** Hero stays undimmed above the backdrop, still below `floatZ`. */
  heroAboveBackdropZ: 350,
  // maxHeightFraction: 0.8,
  sheetChromeH: 118,
  columnBottomInsetFraction: 0.16,
  panelWidthFraction: 0.88,
  panelMaxWidth: MAIN_SCREEN_PANEL_MAX_WIDTH,
  /** iOS scale travel — `wh * 15 / 100`. */
  panelVhFractionIos: 0.15,
  maxHeightFraction: 0.8,
} as const;

export const MAIN_SCREEN_AUTH_BAR = {
  marginBottom: 15,
  chipRowHeight: 72,
  dismissReserveExtra: 20,
} as const;

export const MAIN_SCREEN_FORM = {
  motionVariant: 'mainScreenV3' as const,
};

/** Bottom-sheet panel lift when the IME is open (iOS + Android). */
export const MAIN_SCREEN_KEYBOARD = {
  /** Gap between panel bottom edge and keyboard top. */
  panelClearancePx: appTheme.spacing.sm,
  /** Scroll/focus clearance above keyboard for focused fields. */
  fieldFocusClearancePx: appTheme.spacing.md,
} as const;
